var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "linkIcon2",
    d: "M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0m2.435,9.319L8.5,12.833a.642.642,0,0,1-.431.179.625.625,0,0,1-.4-.148.4.4,0,0,1-.058-.058.5.5,0,0,1,.042-.7l2.587-3.154L7.508,5.837a.5.5,0,0,1,.062-.7.751.751,0,0,1,.41-.148.591.591,0,0,1,.4.148l3.067,3.442a.516.516,0,0,1,.158.4.5.5,0,0,1-.17.344",
    fill: "#316bb9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon2);
export default __webpack_public_path__ + "static/media/linkIcon2.2f5135b2a84ec4c176f9837b986a5d0c.svg";
export { ForwardRef as ReactComponent };